import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap} from './PlaySounds';


class SourcesScreen extends Component {

  

      goToMainMenu = () => {
        playButtonTap();
        this.props.history.push('/mainmenu');
    };
    

    render() {
      const sourceItems = this.props.sources.map(source =>(
      <li key = {source.id}>{source.source}<br/><a href ={source.url} target ="_blank" rel="noopener noreferrer">{source.url}</a></li>
      ));
      var title = ""
      var direction = "";
      if(this.props.language === "en"){
           title = "Sources";
           direction = "ltr";
      }else if(this.props.language === "ur"){
          title = "ذرائع"
          direction = "rtl";
      }
            return(
                <div className = "screen_background popup_top_padding">
                  <div className = "popup">
                    <div dir={direction} className = "scroll_pupop_title">
                        {title}
                    </div>
                    <div  className= "scroll_div scroll_div_with_title">
                      <div dir="ltr">
                        <ul className = "source_list">
                          {sourceItems}
                        </ul> 
                      </div>  
                      </div>
                  </div>
                  <img src={"./images_"+this.props.language+"/btn_back.png"} alt="" className="button" onClick = {this.goToMainMenu}/>
                </div>
            )
    }
}

SourcesScreen.propTypes = {
  sources:PropTypes.array.isRequired,
  language:PropTypes.string.isRequired
}
const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en"),
  sources: state.localData.sources
});
export default connect(mapStateToProps)(SourcesScreen);
//export default withRouter(IntroScreen);



// WEBPACK FOOTER //
// ./src/components/SourcesScreen.js